import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Learn = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M21 16.0306V5.71567C21 4.69016 20.118 3.92957 19.047 4.01503H18.993C17.103 4.16886 14.232 5.08327 12.63 6.04041L12.477 6.13441C12.216 6.28824 11.784 6.28824 11.523 6.13441L11.298 6.00623C9.696 5.05763 6.834 4.15177 4.944 4.00649C3.873 3.92103 3 4.69016 3 5.70712V16.0306C3 16.851 3.702 17.6201 4.566 17.7226L4.827 17.7568C6.78 18.0047 9.795 18.9447 11.523 19.842L11.559 19.8591C11.802 19.9873 12.189 19.9873 12.423 19.8591C14.151 18.9532 17.175 18.0047 19.137 17.7568L19.434 17.7226C20.298 17.6201 21 16.851 21 16.0306Z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M12 6.53784V20.0001'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M8.1749 9.23047H6.1499'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M8.8499 11.9226H6.1499'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    ) : (
      <>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11.2893 4.60167C9.55026 3.56169 7.03567 2.87672 4.99059 2.71731C3.42686 2.59175 2.04688 3.75086 2.04688 5.37302V15.9262C2.04688 17.2586 3.12676 18.4098 4.42452 18.5689L4.68336 18.6032L4.68698 18.6037C6.55411 18.8434 9.4964 19.7721 11.1461 20.6391L11.158 20.6452L11.1752 20.6537L11.198 20.6646C11.2281 20.6802 11.2586 20.6946 11.2893 20.708V4.60167ZM4.21862 8.97484C4.21862 8.5514 4.5578 8.20814 4.97619 8.20814H7.02165C7.44005 8.20814 7.77922 8.5514 7.77922 8.97484C7.77922 9.39827 7.44005 9.74153 7.02165 9.74153H4.97619C4.5578 9.74153 4.21862 9.39827 4.21862 8.97484ZM4.97619 10.9605C4.5578 10.9605 4.21862 11.3037 4.21862 11.7271C4.21862 12.1506 4.5578 12.4938 4.97619 12.4938H7.70347C8.12186 12.4938 8.46104 12.1506 8.46104 11.7271C8.46104 11.3037 8.12186 10.9605 7.70347 10.9605H4.97619Z'
          fill='currentColor'
        />
        <path
          d='M12.8045 4.59629V20.7006C12.8372 20.6856 12.8697 20.6695 12.9018 20.6519C14.55 19.7789 17.4919 18.8448 19.365 18.6044L19.6599 18.57L19.6631 18.5696C20.9636 18.4134 22.0469 17.2607 22.0469 15.9262V5.38176C22.0469 3.7557 20.6717 2.61989 19.1322 2.72324H19.1105C19.0859 2.72324 19.0613 2.72425 19.0368 2.72627C17.2056 2.8771 14.5822 3.67605 12.8045 4.59629Z'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
